module.exports = __webpack_public_path__ + "img/1_uk.5a091371.svg";